// The one manual-stage adjustment a cell's "Independent" edit owns, so a later edit replaces it
// rather than stacking. `theme` is the identity; `name` is only a label a planner's row can share.
export const MANUAL_ADJUSTMENT_NAME = "Manual adjustment"
export const CELL_DELTA_THEME = "cell-delta"

export const isCellDelta = (a: { name: string; theme: string | null }) =>
  a.theme === CELL_DELTA_THEME
